<template>
  <!--红冲流程 http://localhost:8080/#/Order/order/orderRedFlushFlow -->
  <div>
    <div class="ti d-flex">
      <div class="d-flex-left">
        <erp-tree @node-click="nodeClick"></erp-tree>
      </div>
      <div class="d-flex-right" :style="task_id">
        <el-button @click="flow">提交流程</el-button>
        <el-button @click="order_add">添加红冲账单</el-button>
        <el-button @click="del(1)">删除</el-button>
        <el-button @click="del(2)">全部删除</el-button>
<!--        <el-button @click="excelAdd">导入</el-button>-->
        <el-button @click="selects(1)">查询</el-button>
        <!-- 查询条件 -->
        <div style="width: 99%;">
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item label="查询房产">
              <el-autocomplete
                v-model="house"
                size="mini"
                style="width: 100%;"
                :fetch-suggestions="querySearchAsync"
                placeholder="可搜索房产"
                clearable
                @select="handleSelect"
              ></el-autocomplete>
            </el-descriptions-item>
            <el-descriptions-item label="收费项">
              <el-select v-model="data.select_charge_id" @change="chargeItem_names" style="width: 100%" clearable size="mini" placeholder="收费项">
                  <el-option
                    v-for="item in chargeitem"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item  label="计费周期">
              <el-date-picker v-model="data.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="data.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item  label="">
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 调整 -->
        <div style="width: 99%;">
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
           <el-descriptions-item label="按百分比红冲">
             <el-input size="mini" style="width:80%" v-model="data.money" placeholder="如红冲70%,填写0.7,填1,100%红冲"></el-input>
             <el-button size="mini" @click="charge(1)">确定调整</el-button>
           </el-descriptions-item>
           <el-descriptions-item label="按金额红冲">
             <el-input size="mini" style="width:80%" v-model="data.money1" placeholder="如红冲50元,填写50"></el-input>
             <el-button size="mini" @click="charge(2)">确定调整</el-button>
           </el-descriptions-item>
          </el-descriptions>
        </div>

        <div style="width: 99%; margin-top: 10px;">
          <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
          <span style="margin-left: 15px;">缴款金额：<span style="color: red;">{{money}}</span>元</span>
          <span style="margin-left: 15px;">减免金额：<span style="color: red;">{{money1}}</span>元</span>
          <span style="margin-left: 15px;">红冲金额：<span style="color: red;">{{money3}}</span>元</span>
          <span style="margin-left: 15px;">操作后剩余缴款金额：<span style="color: red;">{{money2}}</span>元</span>
          <span style="color:red;margin-left: 15px;">操作说明，1、添加红冲账单，2、操作红冲账单，3、提交流程。注：减免金额全部红冲，红冲金额可修改（部分红冲）</span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <div>
            <el-table ref="multipleTable" height="50vh" :data="orderData" border style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" > </el-table-column>
              <el-table-column prop="name" label="业户" width="100"></el-table-column>
              <el-table-column prop="h_name_date" label="房产" width="250"></el-table-column>
              <el-table-column prop="chargeItem_name" label="收费标准" width="180"></el-table-column>
              <el-table-column label="计费周期" width="170">
                <template slot-scope="scope">{{scope.row.startDate}}-{{scope.row.endDate}}</template>
              </el-table-column>
              <el-table-column prop="xsc_Price" label="单价" width="70"></el-table-column>
              <el-table-column label="数量" width="70">
                <template slot-scope="scope">{{scope.row.xsc_Amount}}</template>
              </el-table-column>
              <el-table-column label="房产面积" width="70">
                <template slot-scope="scope">{{scope.row.charging}}</template>
              </el-table-column>
              <el-table-column label="缴款金额" width="70">
                <template slot-scope="scope">{{scope.row.paymentCharge}}</template>
              </el-table-column>
              <el-table-column label="减免金额" width="70">
                <template slot-scope="scope">{{scope.row.discountCharge}}</template>
              </el-table-column>
<!--              <el-table-column label="减免违约金" width="90">
                <template slot-scope="scope">{{scope.row.delay_dis_count}}</template>
              </el-table-column>-->
              <el-table-column label="红冲金额" width="100">
                <template slot-scope="scope">
                  <el-input size="mini" @change='delayCharge(orderData[scope.$index],scope.$index)' v-model="orderData[scope.$index].PaidChargeSum"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作后剩余缴款金额" width="130">
                <template slot-scope="scope">{{scope.row.money}}</template>
              </el-table-column>
              <el-table-column prop="date" label="添加时间" width="150"></el-table-column>
              <el-table-column label="后缴款金额" width="90">
                <template slot-scope="scope">
                  {{scope.row.afterPaid}}
                </template>
              </el-table-column>
              <el-table-column label="操作缴款" width="100">
                <template slot-scope="scope">
                  <el-button style="color: #1e73e9" type="text" @click="getAfterPaid(scope.row.id,scope.row.h_name_date)">查看</el-button>
                  <el-button style="color: #1e73e9" type="text" @click="pay_order_add(scope.row.id,scope.row.h_name_date)">添加</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pages">
            <el-pagination @size-change="selects_size"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20,50,100,200,300,400,500]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Modal
       v-model="modal"
       ok-text="确定"
       width="400"
       :loading="loadingModal"
       title="数据上传"
       @on-ok="addexcels">
       <div>
          <el-form style="height: 300px;overflow: auto;">
            <div class="cdj_margin_span">
             <span><span class="cdj_span">*</span>上传文件</span>
             <el-upload
                 style="color: #ffffff;"
                 class="upload-demo cdj_input"
                 :action="url"
                 :before-remove="beforeRemove"
                 :on-success="handleAvatarSuccess"
                 accept=".xls,.xlsx"
                 multiple
                 :limit="1"
                 :on-exceed="handleExceed"
                 :file-list="fileList"
                 :before-upload="beforeAvatarUpload">
                 <el-button size="small" type="primary" class="texts">点击上传</el-button>
                 <div slot="tip" class="el-upload__tip">只能上传xls或xlsx文件，不能大于15m</div>
             </el-upload>
            </div>
          </el-form>
       </div>
    </Modal>
    <selectAdiustRedFlush ref="selectAdiust"></selectAdiustRedFlush>
    <!-- 已付款 -->
    <afterPaid ref="afterPaid"></afterPaid>
    <selectAdiustRedFlushPayment ref="selectAdiustOrder"></selectAdiustRedFlushPayment>
  </div>
</template>

<script>
  import ViewFlow from "../../Common/ViewFlow.vue";

  export default {
    data () {
      return {
        loadingModal: false,
        dialogVisible9: false,
        pageData:{
          id:0,
          pid:0,
          list:[],
          total:0,
          page:1,
          pageSize:10,
        },
        fileList:[],
        modal:false,
        url:'',
        task_id:'',
        type:false,
        orderData:[],
        page:1,
        pageSize:20,
        total:0,
        chargeitem:[],
        chargeitems:[],
        order:[],
        money:0,
        money_val:0,
        money1:0,
        money2:0,
        money3:0,
        red_id:'',
        pid:'',
        house:'',
        loading_dade:1,
        data:{
          moneyType:'单价,用量,金额联动',
          select_charge_id:'',
          chargeItem_name_id:'',
          chargeItem_name_ids:'',
          startDate:'',
          endDate:'',
          money:'',
          money1:'',
          url:'',
        }
      }
    },
    created(){
      var login = window.localStorage.getItem('login');
      var token = window.localStorage.getItem('token');
      this.url = this.$myhttp.defaults.baseURL + "/admin/excel?"+"login_name="+login+"&token="+token;
      let task_id = this.$route.query.task_id;
      let number = this.$route.query.number;
      if(task_id){
        this.task_id='margin-top: 10px;margin-left: 10px;'
        this.type = false;
      }else{
        this.task_id='margin-top: 10px'
        this.type = true;
      }
    },
    components: {
      ViewFlow,
      "erp-tree": () => import('../../Common/erp-tree-adiust.vue'),
      "selectAdiustRedFlush": () => import('./selectAdiustRedFlush.vue'),
      "afterPaid": () => import('./afterPaid.vue'),
      "selectAdiustRedFlushPayment": () => import('./selectAdiustRedFlushPayment.vue'),
    },
    methods: {
       //导入
       excelAdd(){
          if(this.pid == ''){
            this.$Message.error('点击左边树选择项目');
            return false;
          }
          this.modal = true;
       },
       //超过一个文件
       handleExceed(files, fileList) {
        // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        this.$message.warning(`一次只允许上传1个文件`);
       },
       //删除
       beforeRemove(file, fileList) {
         this.tableData = [];
         this.total = 0;
         this.money = 0;
         return this.$confirm(`确定移除 ${ file.name }？`);
       },
       //限制大小
       beforeAvatarUpload(file){
         const isLt7M = file.size / 1024 / 1024 < 15;
         if (!isLt7M) {
           this.$message.error('上传文件大小不能超过 8MB!');
         }
         return isLt7M;
       },
       //上传成功返回
       handleAvatarSuccess(res, file){
         this.data.url = file.response[0];
         //console.log(369369);
         this.type=2;
       },
       //导入
       addexcels(){
        ERP.showLoading()
        let data = {'data':this.data,'house':this.house,'pid':this.pid}
        this.$myhttp.post('admin/OrderRedFlushFlow/addexcel',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading()
          this.$Message.success('操作成功!');
          this.selects(this.page);
        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求异常!');
        });
       },
       //跳流程
       flow(){
         if(this.pid == ''){
            this.$Message.error('点击左边树选择项目');
            return false;
         }
         if(this.orderData.length < 1){
           this.$Message.error('没有账单');
           return false;
         }
         this.$confirm('确定操作吗, 是否继续?', '提示', {
           confirmButtonText: '确定',
           cancelButtonText: '取消',
           type: 'warning'
         }).then(() => {
           let data = {'data': this.data, 'house': this.house, 'pid': this.pid, 'order': this.order}
           ERP.showLoading()
           this.$myhttp.post('admin/OrderRedFlushFlow/adjustAdd', data, {
             'Content-Type': 'application/x-www-form-urlencoded'
           }).then(backdata => { // 异步执行成功后1
             ERP.hideLoading()
             if (backdata.data.code == 200) {
               this.$Message.success('操作成功!');
               const timestamp = Date.parse(new Date());
               let url = "/#/flow/FlowView?sheet_id=247&master_id=134&timeValue="+timestamp+"&batch="+backdata.data.data;
               window.open(url, '_blank');
               this.selects(this.page);
             } else {
               this.$Message.error(backdata.data.message);
             }
           }, err => {
             ERP.hideLoading()
             this.$Message.error('请求异常!');
           });
         })


         // let number = this.orderData[0]['number'];
         // const timestamp = Date.parse(new Date());
         //https://crm.gdzawy.com:9000/#/flow/FlowView?sheet_id=167&master_id=134&timeValue=1716599765586
         // let url = "/#/flow/FlowView?sheet_id=167&master_id=134&timeValue="+timestamp+"&batch="+number;
         // window.open(url, '_blank');
       },
       //删除
       del(e){
        if(this.pid == ''){
           this.$Message.error('点击左边树选择项目');
           return false;
        }
        this.$confirm('确定操作吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.showLoading()
          let data = {'data':this.data,'house':this.house,'pid':this.pid,'type':e,'order':this.order}
          this.$myhttp.post('admin/OrderRedFlushFlow/del',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            this.$Message.success('操作成功!');
            this.selects(this.page);
          },err=>{
            ERP.hideLoading()
            this.$Message.error('请求异常!');
          });
        })
       },
       handleSelect(){

       },
       //远程搜索方式
       querySearchAsync(query, cb) {
          if (query !== '') {
            this.loading_dade = 2;
            this.$myhttp.get('admin/common/house_name?house_name='+encodeURIComponent(query),{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.loading_dade = 1;
                let selectList = backdata.data.data;
                let value = [];
                selectList.map(req=>{
                  value.push({'value':req.house})
                })
                cb(value)
            });
          }
       },
       //根据费项批量调整
       charge(e){
        let data = {'data':this.data,'pid':this.pid,'house':this.house,'type':e}
        ERP.showLoading()
        this.$myhttp.post('admin/OrderRedFlushFlow/chargeUpdate',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{
            ERP.hideLoading()
            this.selects(this.page);
            if(backdata.data.code == 201){
              this.$Message.error(backdata.data.message);
              return false;
            }
            if(backdata.data.code == 200){
              this.$Message.success('操作成功!');
            }
        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求异常!');
        });
       },
       //减免
       charge1(e){
         let data = {'data':this.data,'pid':this.pid,'house':this.house,'type':e}
         ERP.showLoading()
         this.$myhttp.post('admin/OrderPaymentFlow/chargeUpdate1',data,{
           'Content-Type': 'application/x-www-form-urlencoded'
           }).then(backdata=>{
             ERP.hideLoading()
             this.selects(this.page);
             if(backdata.data.code == 201){
               this.$Message.error(backdata.data.message);
               return false;
             }
             if(backdata.data.code == 200){
               this.$Message.success('操作成功!');
             }
             // this.chargeitems = backdata.data.data;
         },err=>{
           ERP.hideLoading()
           this.$Message.error('请求异常!');
         });
       },
       //费项
       chargeItem_names(){
         let data = {'data':this.data,'pid':this.pid}
         this.$myhttp.post('admin/OrderAdjust/chargeItem_names',data,{
           'Content-Type': 'application/x-www-form-urlencoded'
           }).then(backdata=>{
             this.chargeitems = backdata.data.data;
         },err=>{
           this.$Message.error('请求异常!');
         });
       },
       //红冲金额
       delayCharge(val){
         let data = {'data':val,'type':2,'select':this.data};
         this.loading_dade = 2;
         this.$myhttp.post('admin/OrderRedFlushFlow/update',data,{
           'Content-Type': 'application/x-www-form-urlencoded'
           }).then(backdata=>{
              this.loading_dade = 1;
             if(backdata.data.code == 201){
               this.$Message.error(backdata.data.message);
             }else{
               this.$Message.success(backdata.data.message);
             }
            this.selects(this.page);
         },err=>{
           this.$Message.error('请求异常!');
         });
       },
       handleSelectionChange(val){
         console.log('order',val)
        this.order = val;
        let money = 0;
        this.order.map(req=>{
            // money = Number(money) + Number(req.charge);
            money = Number(money) + Number(req.PaidChargeSum);
        })
        this.money_val = money.toFixed(2);
       },
       handleCurrentChange(e){
         this.page = e;//第几页
         this.selects(this.page);
       },
       selects_size(e){
         this.pageSize = e;
         this.selects(this.page);
       },
       // 查询
       selects(e){
         if(this.pid == ''){
           this.$Message.error('点击左边树选择项目');
           return false;
         }
         if(e){
           this.page = e;
         }
         this.chargeitems = [];
         this.data.chargeItem_name_id = '';
         this.data.chargeItem_name_ids = '';
         this.loading_dade = 2;
         let data = {'data':this.data,'house':this.house,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
         this.$myhttp.post('admin/OrderRedFlushFlow/orderList',data,{
           'Content-Type': 'application/x-www-form-urlencoded'
           }).then(backdata=>{ // 异步执行成功后
             this.orderData = backdata.data.data;
             this.total = backdata.data.count;
             this.money = backdata.data.money;
             this.money1 = backdata.data.money1;
             this.money2 = backdata.data.money2;
             this.money3 = backdata.data.money3;
             this.chargeitem = backdata.data.charge;
             this.loading_dade = 1;
         },err=>{
           this.loading_dade = 1;
           this.$Message.error('请求异常!');
         });
       },
       //添加账单
      order_add(){
         if(this.pid == ''){
           this.$Message.error('点击左边树选择项目');
           return false;
         }
         this.$refs.selectAdiust.getInvo(this.house,this.pid);
      },
      //点击已缴款
      after_paid_list(red_house){
        if(this.pid == ''){
          this.$Message.error('点击左边树选择项目');
          return false;
        }
        this.$refs.afterPaid.getInvo(this.house,this.pid,this.red_id,red_house);
      },
      //
      getAfterPaid(red_id,red_house) {
        console.log('red_house',red_house);
        if (red_id) {
          this.red_id = red_id;
        }else{
          this.$Message.error('请点击红冲缴款账单');
          return false;
        }
        this.house = red_house;
        this.after_paid_list(red_house)
      },
      //添加缴款账单
      pay_order_add(red_id,red_house){
        console.log('red_house',red_house);
        if(this.pid == ''){
          this.$Message.error('点击左边树选择项目');
          return false;
        }
        if (red_id) {
          this.red_id = red_id;
        }else{
          this.$Message.error('请点击红冲缴款账单');
          return false;
        }
        this.house = red_house;
        this.$refs.selectAdiustOrder.getInvo(this.house,this.pid,this.red_id);
      },
      //点击树
      nodeClick(data){
        this.pid = data.tree[0].pindex_id;
        let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
        this.house=tree_str;
        this.selects(this.page);
      },
    }
  }
</script>

<style>
  .ti{
    background-color: white;
  }
  .d-flex {
    display: flex;
  }
  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
    width: 250px;

  }
  .d-flex-right {
    flex: 1;
    overflow-x:hidden;
  }
  .text2{
    color: rgb(250, 248, 248);
  }
</style>

<style lang="scss" scoped>
  .right-main {
    display: flex;
    // overflow: auto;//体内容的滚动条
    flex: 1;
    background: #fff;
  }
</style>




// WEBPACK FOOTER //
// src/components/Admin/Order/order/orderRedFlushFlow.vue